<div class="div_venue">
  <div class="w-100 venues-header-container">
    <label class="lbl_top_venues">{{'VENUE.ALL_VENUES' | translate}}</label>
  </div>
  <div class="venues-container"
       [class.unset-grid-settings]="spinner"
       [class.no-venues-screen]="!spinner && listAllVenues.length === 0"
       style="overflow: auto;box-sizing: border-box;max-height: 100%;">
    <p-progressSpinner class="w-100 text-center resy_spinner_relative" *ngIf="spinner"></p-progressSpinner>
    <ng-container *ngIf="!spinner && listAllVenues.length === 0; else list">
      <div class="w-100"><img src="assets/icons/venue-icon.svg" alt="Venue icon"></div>
      <div class="w-100 add-venue-message">{{'There are no venues.' | translate}}</div>
    </ng-container>
    <ng-template #list>
      <div *ngFor="let venues of listAllVenues" class="div_card_venue">
        <div [routerLink]="'/venues/' + venues.id +'/reservations'">
          <div class="w-100 d-flex flex-wrap justify-content-center venue-logo-container">
            <img class="mb-2 venue-logo"
                 [src]="venues.pictureUrl ? venues.pictureUrl : imagePath"
                 alt="profile-picture">
            <div class="w-100"></div>
            <span class="venue-name" title="{{venues.name}}">{{venues.name}}</span>
          </div>
          <div class="w-100 d-flex flex-wrap">
            <div class="w-100 venue-info-container">
              <label class="lbl-venue">
                <img src="assets/icons/phone_bluetooth_speaker_24px.svg" alt="Phone icon">
              </label>
              <label class="lbl-venue-value">{{venues.phone}}</label>
            </div>
            <div class="w-100 venue-info-container">
              <label class="lbl-venue">
                <img src="assets/icons/add_location_24px.svg" alt="Location icon">
              </label>
              <label class="lbl-venue-value" title="{{venues.address}}">{{venues.address}}</label>
            </div>
          </div>
        </div>
        <div class="w-100 d-flex flex-wrap add-host-venue-btn-container">
          <button class="create_btn w-100 mt-0"
                  (click)="openEditCapacityForVenue(venues.id)">{{ 'VENUE.EDIT_CAPACITY' | translate}}</button>
        </div>
      </div>
    </ng-template>
  </div>
</div>
